import { toFormData } from '../lib/utils/forms';
import { axiosAPI } from './axios-instance';
import { ApiResponse } from './lib/types';

export type ApiProjectRegistrationRequest = {
    name: string;
    last_name: string;
    email: string;
    phone: number;
    inn?: string;
    company?: string;
    city: string;
    short_project_name: string;
    theme: string;
    sentence_type: string;
    readiness_stage: string;
    short_description: string;
    volume_products?: string;
    customers_consumers?: string;
    presentations: string[];
    documents: string[];
    registered_address?: string;
    kpp?: string;
    ogrn?: string;
    is_physical_person?: number;
    agreementChecked: number;
    agreementCheckedProcessingPersonalData: number;
    theme_track?: string;
    url?: string;
    submit_prize?: boolean;
    submit_tnf_days?: boolean;
};

export type AppProjectRegistrationRequest = {
    lastname: string;
    shortName: string;
    theme: string;
    type: string;
    stage: string;
    amount: string;
    customers: string;
    name: string;
    inn: string;
    resume: string;
    email: string;
    phone: string;
    agreementChecked: number;
    agreementCheckedProcessingPersonalData: number;
    city: string;
    presentationUrls: string[];
    documentUrls: string[];
    check_val: string;
    submitPrizeDestination?: boolean;
    submitTnfDestination?: boolean;
    themeTrack?: string;
};

export type ApiProjectRegistrationResponse = ApiResponse<{
    message: string;
}>;

export type AppProjectRegistrationResponse = ApiResponse<{
    message: string;
}>;

const transformApiResponse = (response: ApiProjectRegistrationResponse): AppProjectRegistrationResponse => {
    return response;
};

export const postProjectRegistration = (body: ApiProjectRegistrationRequest): Promise<AppProjectRegistrationResponse> =>
    axiosAPI
        .post<ApiProjectRegistrationResponse>('/v1/feedback/tech-day', body)
        .then((res) => transformApiResponse(res.data));
